import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=b96999be&scoped=true&"
import script from "./Answer.vue?vue&type=script&lang=js&"
export * from "./Answer.vue?vue&type=script&lang=js&"
import style0 from "./Answer.vue?vue&type=style&index=0&id=b96999be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96999be",
  null
  
)

export default component.exports